export const InsuranceCompanyOptions = [
  { label: "SecureGuard Insurance", value: "SecureGuard Insurance" },
  { label: "Apex Assurance", value: "Apex Assurance" },
  { label: "Liberty Shield Insurance", value: "Liberty Shield Insurance" },
  { label: "Sentinel Underwriters", value: "Sentinel Underwriters" },
  { label: "Golden Horizon Assurance", value: "Golden Horizon Assurance" },
  { label: "Integrity Insurance Co.", value: "Integrity Insurance Co." },
  { label: "EverSafe Insure", value: "EverSafe Insure" },
];

export const InsurancePolicyTypes = [
  { label: "Group Medical", value: "GroupMedical" },
  { label: "Group Life", value: " GroupLife" },
  { label: "Group PA", value: "GroupPA" },

];

export const InsurancePolicycontainer = [
  { label: "Apex Assurance", value: "Apex Assurance", sumInsured: "65000" },
  { label: "Liberty Shield Insurance", value: "Liberty Shield Insurance", sumInsured: "97500" },
  { label: "Sentinel Underwriters ", value: "Sentinel Underwriters", sumInsured: "32500" },


];

export const pesoTypes = [
  { label: "peso", value: "peso" },
  { label: "INR", value: "INR" },
  // { label: "MCY", value: "HL" },
  // { label: "CV", value: "CV" },

];

export const PremiumCurrency = [
  { label: "peso", value: "peso" },
  { label: "INR", value: "INR" },

];
export const InstallmentType = [
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Half yearly", value: "Half yearly" },
  { label: "yearly", value: "yearly" },


];

export const PolicyTypes = [
  { label: "Cash", value: "Cash" },
  { label: "Credit", value: "Credit" },

];

export const AccountCodes = [
  { label: "ACME001", value: "ACME001" },
  { label: "XYZ123", value: "XYZ123" },
  { label: "BLU567", value: "BLU567" },
  { label: "CORP789", value: "CORP789" },
  { label: "MAGIC456", value: "MAGIC456" },
  { label: "FAB789", value: "FAB789" },
];

export const VehicleBrands = [
  { label: "Top Management/C-Suite", value: "Top Management/C-Suite" },
  { label: "Senior Managment", value: "Senior Managment" },
  { label: "Middle Managment", value: "Middle Managment" },
  { label: "Junior/Staff Level", value: "Junior/Staff Level" },
  { label: "Field/Operations Staff", value: "Field/Operations Staff" },
];

export const ModelYears = [
  { label: "Domestic", value: "Domestic" },
  { label: "Nationwide", value: "Nationwide" },
  { label: "Regional", value: "Regional" },
  { label: "Worldwide", value: "Worldwide" }, 
];

export const VehicleModels = [
  { label: "3 Series", value: "3 Series" },
  { label: "Rav4", value: "Rav4" },
  { label: "Mustang", value: "Mustang" },
  { label: "CR-V", value: "CR-V" },
];


export const ModelVariants = [
  { label: "X5", value: "X5" },
  { label: "Camry", value: "Camry" },
  { label: "Fusion", value: "Fusion" },
  { label: "Accord", value: "Accord" },
];


export const VehicleColors = [
  { label: "Quantum Blue", value: "QuantumBlue" },
  { label: "Solar Flare Red", value: "SolarFlareRed" },
  { label: "Galactic Silver", value: "GalacticSilver" },
  { label: "Nebula Black", value: "NebulaBlack" },
  { label: "Stellar White", value: "StellarWhite" },
  { label: "Velocity Green", value: "VelocityGreen" },
];
